import FakeSettingsApi from "./FakeSettingsApi";
import RealSettingsApi from "./RealSettingsApi";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import NoticeSaveReqDto from "../dto/settings/NoticeSaveReqDto";
import NoticeUpdateReqDto from "../dto/settings/NoticeUpdateReqDto";
import GuideSaveReqDto from "../dto/settings/GuideSaveReqDto";
import GuideUpdateReqDto from "../dto/settings/GuideUpdateReqDto";
import CoursePriceUpdateReqDto from "../dto/settings/CoursePriceUpdateReqDto";
import SuccessResponse from "../dto/common/SuccessResponse";

type TargetClientType = "MANAGER" | "CUSTOMER" | "ALL";

class SettingsApi {
    fakeApi = false;
    fake = new FakeSettingsApi();
    real = new RealSettingsApi();

    // ===================== Notice =====================

    getNotice = ({ country, targetClientType }: { country: string; targetClientType: TargetClientType }) => {
        if (this.fakeApi) {
            return this.fake.getNotice();
        } else {
            return this.real.getNotice({ country, targetClientType });
        }
    };

    saveNotice = (reqDto: NoticeSaveReqDto) => {
        if (this.fakeApi) {
            return this.fake.saveNotice();
        } else {
            return this.real.saveNotice(reqDto);
        }
    };

    updateNotice = (reqDto: NoticeUpdateReqDto) => {
        if (this.fakeApi) {
            return this.fake.updateNotice();
        } else {
            return this.real.updateNotice(reqDto);
        }
    };

    deleteNotice = ({ country, targetClientType }: { country: string; targetClientType: TargetClientType }) => {
        if (this.fakeApi) {
            return this.fake.deleteNotice();
        } else {
            return this.real.deleteNotice({ country, targetClientType });
        }
    };

    // ===================== Guide =====================

    getGuideList = (params: {
        guideId?: string;
        title?: string;
        subtitle?: string;
        modelType?: string;
        language?: string;
        guideType?: string;
        deviceType?: string;
        seq?: string;
        code?: string;
        page?: number;
        pageSize?: number;
    }) => {
        if (this.fakeApi) {
            return this.fake.getGuideList();
        } else {
            return this.real.getGuideList(params);
        }
    };

    saveGuide = (reqDto: GuideSaveReqDto) => {
        if (this.fakeApi) {
            return this.fake.saveGuide();
        } else {
            return this.real.saveGuide(reqDto);
        }
    };

    updateGuide = (reqDto: GuideUpdateReqDto) => {
        if (this.fakeApi) {
            return this.fake.updateGuide();
        } else {
            return this.real.updateGuide(reqDto);
        }
    };

    deleteGuide = ({ guideId }: { guideId: string }) => {
        if (this.fakeApi) {
            return this.fake.deleteGuide();
        } else {
            return this.real.deleteGuide({ guideId });
        }
    };

    // ===================== Course Image & Price =====================

    uploadCourseImage = ({ imageNum, version, content }: { imageNum: string; version: string; content: File }) => {
        if (this.fakeApi) {
            return this.fake.uploadCourseImage();
        } else {
            return this.real.uploadCourseImage({ imageNum, version, content });
        }
    };

    deleteCourseImage = ({ imageNum, version }: { imageNum: string; version: string }) => {
        if (this.fakeApi) {
            return this.fake.deleteCourseImage();
        } else {
            return this.real.deleteCourseImage({ imageNum, version });
        }
    };

    updateCoursePrice = ({
        deviceId,
        reqDto,
    }: {
        deviceId: string;
        reqDto: CommonRequestBodyDto<CoursePriceUpdateReqDto>;
    }) => {
        if (this.fakeApi) {
            return this.fake.updateCoursePrice();
        } else {
            return this.real.updateCoursePrice({ deviceId, reqDto });
        }
    };

    async getCourseImages({
        imageNum,
        version,
        page,
        pageSize,
    }: {
        imageNum: string | undefined;
        version: string | undefined;
        page: number;
        pageSize: number;
    }): Promise<SuccessResponse<object>> {
        if (this.fakeApi) {
            return this.fake.getCourseImages();
        } else {
            return this.real.getCourseImages({ imageNum, version, page, pageSize });
        }
    }
}

export default SettingsApi;
